import { Fragment } from 'react';

import type { MenuProps } from './types';

import { FilterActionButtons } from '../actions-buttons';
import { FilterComparer } from '../common';
import { useFilterTranslate } from '../filter-utils';
import { FilterListItem } from '../list-item';
import { FilterSelectionIcon } from '../selection-icon';

const DEFAULT_SELECT_COMPARERS = [
  'is',
  'not_is',
  'any_of',
  'none_of',
] satisfies Array<FilterComparer>;

export const SelectMenu = ({ state, actions, config }: MenuProps) => {
  const { t } = useFilterTranslate();

  if (!('values' in config)) return null;

  const comparers =
    ('allowedComparers' in config && config.allowedComparers) || DEFAULT_SELECT_COMPARERS;
  const isMultiSelect = state.comparer === 'any_of' || state.comparer === 'none_of';

  // Get values - either static array or dynamically computed based on current state
  const values = typeof config.values === 'function' ? config.values(state) : config.values;

  if (!state.comparer) {
    return (
      <Fragment>
        {comparers.map((comparer) => (
          <FilterListItem
            key={comparer}
            label={t(`core.comparator.${comparer}`)}
            onClick={() => actions.selectComparer(comparer)}
          />
        ))}
      </Fragment>
    );
  }

  return (
    <Fragment>
      {values.map((item) => {
        const isSelected = state.value
          ? isMultiSelect
            ? (state.value as string[]).includes(item.value)
            : state.value === item.value
          : false;

        return (
          <FilterListItem
            key={item.value}
            label={item.label}
            icon={item.icon}
            selectionIcon={<FilterSelectionIcon isSelected={isSelected} state={state} />}
            onClick={() => actions.selectValue(item.value)}
          />
        );
      })}
      <FilterActionButtons
        state={state}
        actions={actions}
        disableApply={
          !state.value || (isMultiSelect && Array.isArray(state.value) && state.value.length === 0)
        }
      />
    </Fragment>
  );
};
